import comp from "./ResourceViewItem";
export default comp;
